import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSelectedRows } from '../tabla/SelectedRowsContext';
import '../../estilo/App.css';
import ConfirmUnificarModal from '../modales/UnificarModal';
import axiosInstancePromise from '../../general/axiosConfig';

const BtnUnificar = ({funcSenal}) => {
  const {selectedFiles } = useSelectedRows();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  
  const handleUnificar = (user) => {
    setOpenConfirmModal(true);
  };

  const handleConfirmUnificar = async () => {
    try {
      const camino = localStorage.getItem('pathsop');
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.post(`/soportes-unir`,
        {
            data: { 
              path: camino,
              archivos: selectedFiles,
            },
        }
      );
      setOpenConfirmModal(false);
      funcSenal();
    } catch (error) {
      console.error('Error al intentar unificar los documentos seleccionados:', error);
    }
  };

  return (
    <Box>    
      <Box>
        <Button
        sx={{mt:2}} 
        variant="outlined" 
        onClick={handleUnificar}
        disabled={selectedFiles.length <= 1}
        >
          Unificar en PDF
        </Button>
      </Box>
      <ConfirmUnificarModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={handleConfirmUnificar} 
      />
    </Box>
  );
};

export default BtnUnificar;
